"use strict";exports.objectSwapKeysAndValues=function(e){return Object.keys(e).reduce((function(t,n){return t[e[n]]=n,t}),{})};
//# sourceMappingURL=objectSwapKeysAndValues.cjs.map
